import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { AlertProvider } from './context/AlertContext';
import Header from './components/Header';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import Alert from './components/Alert';
import EventsPage from './pages/EventsPage';
import TournamentInfoPage from './pages/TournamentInfoPage';
import AdminPage from './pages/AdminPage';
import RSVPSuccess from './pages/RSVPSuccess';
import RSVPCancelled from './pages/RSVPCancelled';
import RecapsPage from './pages/RecapsPage';
import PDFViewerPage from './pages/PDFViewerPage';
import './App.css';

const isAdminDomain = window.location.hostname === 'admin.laytonrsvp.com';

function useScrollReveal() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && e.target.classList.add('visible')),
      { threshold: 0.12 }
    );
    const observe = () => document.querySelectorAll('.reveal').forEach((el) => observer.observe(el));
    observe();
    const timer = setTimeout(observe, 400);
    return () => { observer.disconnect(); clearTimeout(timer); };
  });
}

function AppInner() {
  useScrollReveal();
  
  // Set page title based on domain
  useEffect(() => {
    if (isAdminDomain) {
      document.title = 'Admin Nine & Dine';
    } else {
      document.title = 'Nine & Dine Golf Tournament';
    }
  }, []);
  
  return (
    <div className="app-container">
      <Alert />
      <Header />
      <Navigation />
      <div className="content-wrapper">
        <Routes>
          {isAdminDomain ? (
            <>
              <Route path="/" element={<AdminPage />} />
              <Route path="/admin" element={<AdminPage />} />
            </>
          ) : (
            <>
              <Route path="/" element={<TournamentInfoPage />} />
              <Route path="/events" element={<EventsPage />} />
              <Route path="/demo" element={<EventsPage />} />
              <Route path="/rsvp/success" element={<RSVPSuccess />} />
              <Route path="/rsvp/cancelled" element={<RSVPCancelled />} />
              <Route path="/recaps" element={<RecapsPage />} />
              <Route path="/flyer" element={<PDFViewerPage />} />
            </>
          )}
        </Routes>
      </div>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <AlertProvider>
          <AppInner />
        </AlertProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;

